// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Club-admin DigiPing registration overlays (base UI: AIProfilingWizard.css) */

.club-admin-progress {
  width: min(180px, 36vw);
  height: 6px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.club-admin-progress__fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #22d3ee, #34d399 55%, #a78bfa);
  transition: width 0.35s cubic-bezier(0.25, 1, 0.5, 1);
}

.smart-bullet--c .smart-letter {
  background: linear-gradient(135deg, #22d3ee, #0891b2);
}

.smart-bullet--y .smart-letter {
  background: linear-gradient(135deg, #fbbf24, #d97706);
}

.smart-bullet--h .smart-letter {
  background: linear-gradient(135deg, #34d399, #059669);
}

.club-admin-health-intro--invite {
  margin: 0.85rem 0 0.4rem;
}

.onehealth-intro-role {
  margin: 0.2rem 0 0;
  font-size: 0.82rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--wizard-text-muted, #94a3b8);
}

.club-admin-health-intro .who-capsule,
.options-badge-tray .who-capsule,
.options-badge-tray .scforh-dim-status {
  max-height: 42vh;
  overflow-y: auto;
}

.badge-button--grow {
  box-shadow: inset 0 0 0 1px rgba(251, 191, 36, 0.45);
}

.badge-grow-tag {
  display: inline-block;
  margin-left: 0.4rem;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fbbf24;
}

.club-admin-proof-card {
  cursor: pointer;
}

.club-admin-proof-name {
  margin: 0;
  font-size: 0.85rem;
  color: var(--wizard-text-muted, #94a3b8);
}

.club-admin-interest-tray {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.club-admin-interest-tray .inline-input-field {
  width: 100%;
}

.dp-em--c {
  color: #67e8f9;
}

.dp-em--y {
  color: #fbbf24;
}

.dp-em--h {
  color: #6ee7b7;
}

.smart-bullet--a .smart-letter {
  background: linear-gradient(135deg, #a78bfa, #7c3aed);
}

.password-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/ClubAdminProfiling.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,iEAAiE;EACjE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":["/* Club-admin DigiPing registration overlays (base UI: AIProfilingWizard.css) */\n\n.club-admin-progress {\n  width: min(180px, 36vw);\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  overflow: hidden;\n}\n\n.club-admin-progress__fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #22d3ee, #34d399 55%, #a78bfa);\n  transition: width 0.35s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.smart-bullet--c .smart-letter {\n  background: linear-gradient(135deg, #22d3ee, #0891b2);\n}\n\n.smart-bullet--y .smart-letter {\n  background: linear-gradient(135deg, #fbbf24, #d97706);\n}\n\n.smart-bullet--h .smart-letter {\n  background: linear-gradient(135deg, #34d399, #059669);\n}\n\n.club-admin-health-intro--invite {\n  margin: 0.85rem 0 0.4rem;\n}\n\n.onehealth-intro-role {\n  margin: 0.2rem 0 0;\n  font-size: 0.82rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--wizard-text-muted, #94a3b8);\n}\n\n.club-admin-health-intro .who-capsule,\n.options-badge-tray .who-capsule,\n.options-badge-tray .scforh-dim-status {\n  max-height: 42vh;\n  overflow-y: auto;\n}\n\n.badge-button--grow {\n  box-shadow: inset 0 0 0 1px rgba(251, 191, 36, 0.45);\n}\n\n.badge-grow-tag {\n  display: inline-block;\n  margin-left: 0.4rem;\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #fbbf24;\n}\n\n.club-admin-proof-card {\n  cursor: pointer;\n}\n\n.club-admin-proof-name {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--wizard-text-muted, #94a3b8);\n}\n\n.club-admin-interest-tray {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.club-admin-interest-tray .inline-input-field {\n  width: 100%;\n}\n\n.dp-em--c {\n  color: #67e8f9;\n}\n\n.dp-em--y {\n  color: #fbbf24;\n}\n\n.dp-em--h {\n  color: #6ee7b7;\n}\n\n.smart-bullet--a .smart-letter {\n  background: linear-gradient(135deg, #a78bfa, #7c3aed);\n}\n\n.password-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
